import React from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import swal from "sweetalert";
import {
  InputText,
  Form,
  Button,
  Col,
  Row,
  Checkbox,
  Breadcrumb,
  Card,
  Typography,
  Spin,
  SelectInput,
  NumberInput,
} from "common/elements";
import { insertNewRecord, getPermission } from "services/role";

const { Title } = Typography;

class CreateNew extends React.Component {
  state = {
    permissions: [],
    role: [],
    loading: false,
    disabled: false,
    loadingButton: false,
  };

  componentDidMount() {
    this.setState({ loading: true });
    getPermission()
      .then((response) => {
        if (response && response.data && Array.isArray(response.data)) {
          const permissions = response.data.map((value) => {
            return value.children.map((value) => {
              return {
                permissionId: parseInt(value.id),
                status: false,
              };
            });
          });
          this.setState({
            role: response.data,
            permissions: permissions.flat(),
          });
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  goBack() {
    this.props.navigate("/setting/role");
  }

  onFinish = (values) => {
    values.permissions = this.state.permissions;
    this.setState({ loadingButton: true, disabled: true });
    insertNewRecord(values)
      .then(() => {
        this.goBack();
      })
      .catch(error => {
        swal({
          title: "Opps!",
          text: error?.response?.data?.error?.message,
          icon: "error",
          dangerMode: true,
       });
      })
      .finally(() => {
        this.setState({ loadingButton: false, disabled: false });
      });
  };

  onchangeCheckBox = (id) => {
    const permissions = this.state.permissions;
    permissions.forEach((value, index) => {
      if (value.permissionId === parseInt(id)) {
        permissions[index]["status"] = !permissions[index]["status"];
      }
    });
    this.setState({ permissions });
  };

  handleCancel = () => {
    this.goBack();
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    return (
      <>
        <Breadcrumb className="beadcrumb-role">
          <Breadcrumb.Item id="beadcrumb-title">
            {t("text_roles")}
          </Breadcrumb.Item>
          <Breadcrumb.Item id="beadcrumb-subtitle">
            {t("text_new_role")}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div id="role">
        <Spin spinning={this.state.loading}>
          <Form
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            layout="vertical"
            id="role-form"
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_name")}
              requiredMessage={t("text_please_input_role_name")}
            />
            <SelectInput
              name={"code"}
              label={t("text_base_role")}
              placeholder={t("text_select_base_role")}
              required={true}
              errorMessage={t("text_please_select_base_role")}
              valueKey="id" 
              dataSource={[
                { id: "FIFTH_LINE_MANAGER",name: t("text_5th_line_manager")},
                { id: "FOURTH_LINE_MANAGER",name: t("text_4th_line_manager")},
                // { id: "HR_MANAGER",name: t("text_hr_manager")},
                { id: "THIRD_LINE_MANAGER", name: t("text_3rd_line_manager") }, 
                { id: "SECOND_LINE_MANAGER", name: t("text_2nd_line_manager") },  
                { id: "FIRST_LINE_MANAGER", name: t("text_1st_line_manager") },     
                { id: "STAFF", name: t("text_general_staff") },           
                { id: "GUARD", name: t("text_guard") }
              ]}
              />  
             <NumberInput
              name="order"
              label={t("text_order")}
              placeholder={t("text_order")}
              isAutoSelect={true}
              min={0}
            />
            <Row>
              <Title level={5}>{t("text_permissions")}</Title>
            </Row>
            <Row gutter={[16, 16]} id="role-card">
              {this.state.role.length > 0 &&
                this.state.role.map((role, index) => (
                  <Col span={6} key={index} offset={-2}>
                    <Card title={role.module} size="small" id="width-card">
                      <ul>
                        {role.children.map((child, index) => (
                          <li key={index}>
                            <Checkbox
                              onChange={() => this.onchangeCheckBox(child.id)}
                            >
                              {child.key}
                            </Checkbox>
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </Col>
                ))}
            </Row>
            <Row style={{display: 'flex',justifyContent: "center"}}>
            <div className="ant-modal-footer2">
                <Button
                  className="btn-cancel"
                  onClick={this.handleCancel}
                  disabled={this.state.disabled}
                >
                  {t("text_cancel")}
                </Button>
                <Button
                  className="btn-save"
                  type="primary"
                  htmlType="submit"
                  loading={this.state.loadingButton}
                >
                  {t("text_save")}
                </Button>
              </div>
            </Row>
          </Form>
        </Spin>
        </div>
      </>
    );
  }
}

const RoleCreate = () => {
  let navigate = useNavigate();
  return (
    <>
      <CreateNew navigate={navigate} />
    </>
  );
};
export default RoleCreate;
